module.exports = __webpack_public_path__ + "img/tut3.fe607940.gif";